import styled from 'styled-components';
import { ReactComponent as AzureDevOpsIcon } from '@elementary/common-ui/assets/azure_devops_full.svg';
import { ReactComponent as BitbucketIcon } from '@elementary/common-ui/assets/bitbucket_full.svg';
import { ReactComponent as GitHubIcon } from '@elementary/common-ui/assets/github_full.svg';
import { ReactComponent as GitLabIcon } from '@elementary/common-ui/assets/gitlab_full.svg';
import { Button, Flex } from '@elementary/common-ui/components';
import { VersionControl } from 'shared/types';

const ProviderButton = styled(Button).attrs(() => ({
  variant: 'outlined',
}))`
  display: flex;
  height: 64px;
  padding: 24px;
  justify-content: center;
  align-items: center;
  gap: 24px;
  flex: 1 0 0;
`;

type Props = {
  onSelected: (versionControl: VersionControl) => void;
};

const ProviderSelection = ({ onSelected }: Props) => (
  <Flex gap={3}>
    <ProviderButton onClick={() => onSelected('GitHub')}>
      <GitHubIcon />
    </ProviderButton>
    <ProviderButton onClick={() => onSelected('GitLab')}>
      <GitLabIcon />
    </ProviderButton>
    <ProviderButton onClick={() => onSelected('Bitbucket')}>
      <BitbucketIcon />
    </ProviderButton>
    <ProviderButton onClick={() => onSelected('AzureDevOps')}>
      <AzureDevOpsIcon />
    </ProviderButton>
  </Flex>
);

export default ProviderSelection;
